import baseTheme from "@/theme/variant/base"
import { createTheme } from "@mui/material"

export default createTheme(baseTheme)
